module.exports = __webpack_public_path__ + "static/media/FJ.72886fc4.png";